import type { DriveStep } from 'driver.js';

export const settingsTourSteps: DriveStep[] = [
  {
    element: '[data-tour="settings-tabs"]',
    popover: {
      title: 'Einstellungen',
      description: 'Hier verwaltest du dein Profil, Branding, E-Mail-Vorlagen, Buchungsseite und dein Team. Klicke dich durch die Tabs.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="settings-profile"]',
    popover: {
      title: 'Profil & Firma',
      description: 'Dein Name, Firmenname, Adresse und Steuernummer — das erscheint auf Rechnungen und Angeboten.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="settings-branding"]',
    popover: {
      title: 'Branding',
      description: 'Lade dein Logo hoch und wähle ein Farbthema. Dein Logo erscheint auf Rechnungen, Angeboten und im Klienten-Portal.',
      side: 'bottom',
      align: 'start',
    },
  },
];
